export default "/images/rxPotential.svg?604cc61636f493b285440a0c27f1d89c";